var _defs, _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _path12, _path13, _path14, _rect2, _rect3, _path15, _path16, _line, _line2, _line3, _text, _text2, _rect4, _path17, _circle2, _circle3, _circle4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle5, _rect0, _circle6, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g2, _path30, _path31, _path32, _rect1, _rect10, _path33, _path34, _line4, _line5, _line6, _text3, _rect11, _rect12, _rect13, _rect14, _polyline, _path35, _rect15, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUiuXdesigntab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-13,.cls-14,.cls-24,.cls-25,.cls-28,.cls-3,.cls-7{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{stroke:#9a499c;stroke-width:0.95px;}.cls-13,.cls-14,.cls-24,.cls-25,.cls-28,.cls-3,.cls-7{stroke-miterlimit:10;}.cls-4{fill:#322549;}.cls-16,.cls-5{fill:#2f2143;}.cls-6{fill:#faac6d;}.cls-7{stroke:#263238;stroke-width:0.97px;}.cls-13,.cls-14,.cls-24,.cls-25,.cls-7{stroke-linecap:round;}.cls-8{clip-path:url(#clip-path);}.cls-9{fill:#fff;}.cls-10{fill:#9a499b;}.cls-11{fill:#e4a328;}.cls-12,.cls-26{fill:#fdc435;}.cls-13,.cls-24{stroke:#d18653;}.cls-13,.cls-14{stroke-width:0.64px;}.cls-14,.cls-25{stroke:#d58f5e;}.cls-15{font-size:43.68px;}.cls-15,.cls-20{fill:#2d1f44;}.cls-15,.cls-26{font-family:Anta-Regular, Anta;}.cls-16{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-17{fill:#c79ec9;}.cls-18{fill:#a777b3;}.cls-19{fill:#8b56a3;}.cls-21{fill:#263238;}.cls-22{clip-path:url(#clip-path-2);}.cls-23{fill:#2d1f42;}.cls-24,.cls-25{stroke-width:0.61px;}.cls-26{font-size:36.05px;}.cls-27{fill:#e5ac24;}.cls-28{stroke:#fff;stroke-width:1.27px;}.cls-29{fill:#ece0ec;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -0.13)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.84,116.47s1.13-3.21,1.81-3.8a17.87,17.87,0,0,1-7.27-3s-2.6,5.35,5.46,6.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 -0.13)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M680.06,125s-1.07-3-1.72-3.59a16.89,16.89,0,0,0,6.88-2.87s2.47,5.06-5.16,6.46"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "UI UX design tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 765,
    height: 277
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 76.25,
    cy: 38.32,
    r: 9.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.13,205.89h0a10.59,10.59,0,0,0-.11-3.28h0l1.48-2-1-2.27-2.5-.24,0,0a10.63,10.63,0,0,0-2.39-2.24h0l-.4-2.49-2.33-.88-1.94,1.61v0a10.58,10.58,0,0,0-3.28.11h0l-2-1.48-2.27,1-.23,2.5,0,0a10.2,10.2,0,0,0-2.24,2.39h0l-2.48.4-.88,2.33,1.6,1.94h0a10.52,10.52,0,0,0,.12,3.27h0l-1.48,2,1,2.27,2.51.23v0a10.25,10.25,0,0,0,2.4,2.24h0l.39,2.48,2.34.88,1.93-1.6v0a10.59,10.59,0,0,0,3.28-.12h0l2,1.48,2.27-1,.24-2.51h0a10.68,10.68,0,0,0,2.24-2.4h0l2.49-.39.88-2.34Zm-2.56,1.73a8.51,8.51,0,1,1-4.94-11,8.5,8.5,0,0,1,4.94,11",
    transform: "translate(0 -0.13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.67,85.09s.62-.94,4.44,4.54c0,0,.61-4.76-3.12-6.68s-1.32,2.14-1.32,2.14",
    transform: "translate(0 -0.13)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.29,276.93c0-10.43-.06-11.92-.06-11.92l7.13,11.92c5.3.15,31.76,0,39.41,0-13.05-29.12-27-55.38-27-55.38l-.42-7-56.68,4.07c-2.24,11.27-.47,35.94,1.83,58.35C88.57,276.93,100.32,276.88,112.29,276.93Z",
    transform: "translate(0 -0.13)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189.84,180l.57-9.89,6.23-.14s1.32-2.62,3.51-3.38c0,0,5.3-3.6,6.56-3.44,0,0,1.31.31-2.33,4.94,0,0-1.64,1.94,5,1.78,0,0,11,.33,7.51,2.63,0,0,9.26,2.19-6.27,2.7q9.26.45,9.3,1.35t-8.29,2.11s4.5,0,5,1c0,0,1.77,1.36-4.82,1.35,0,0-8.24.66-13.34-1.52l-8.34.51",
    transform: "translate(0 -0.13)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103,146.9s-6.69-5.77-21.33-9.28c0,0,6.6-6.6-.64-28.79l17,11.59s-2.07,13.43,7,14c0,0,0,8.86-2.06,12.44",
    transform: "translate(0 -0.13)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.51,126.15s-14.34,1.23-17.6-12c0,0-3.93-14.26-2.68-18.81s1.51-8,7.36-12a15.1,15.1,0,0,1,19.28,2.11,26.26,26.26,0,0,1,6.34,12.68s2.72,15.16-1.16,19.91c0,0-4,7.51-11.54,8.08",
    transform: "translate(0 -0.13)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.46,104.26a4.66,4.66,0,0,1-.83-2.89,48.92,48.92,0,0,1,2-8.88s.1-2.41-2.79-4c0,0,3.68-5.56,11.36-2.29,0,0,4.09,2.53,8.08-1.5,0,0,4.61-5.07-.78-9,0,0-1.75-1.45-11.54-.71,0,0-25.57,2.42-20.28,12.54,0,0-4.09,4,.87,13.69,0,0,3.81,8,10.35,6.42,0,0,5.12-.69,3.58-3.41",
    transform: "translate(0 -0.13)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.3,112.79s-1.84,1.12-5.41-1.25c0,0-7.76-5.22-2.65-10.44,0,0,6.43-4.39,10.32,6.82,0,0,.61,4-2.26,4.87",
    transform: "translate(0 -0.13)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.15,100.94c.1,1.22-.48,2.25-1.3,2.32s-1.56-.86-1.66-2.07.48-2.25,1.3-2.32,1.56.86,1.66,2.07",
    transform: "translate(0 -0.13)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.07,98.74c.1,1.22-.48,2.25-1.3,2.32s-1.56-.86-1.66-2.07.48-2.25,1.3-2.32,1.56.86,1.66,2.07",
    transform: "translate(0 -0.13)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89,97.94s3-4.21,6.84-1.67",
    transform: "translate(0 -0.13)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M100.8,95.69s3-4.2,6.85-1.66",
    transform: "translate(0 -0.13)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M97.84,116.47s1.13-3.21,1.81-3.8a17.87,17.87,0,0,1-7.27-3s-2.6,5.35,5.46,6.83",
    transform: "translate(0 -0.13)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92.38,109.64v1.26s3.38,2.59,5.58,2.59l1.06-.94",
    transform: "translate(0 -0.13)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.8,102a54.06,54.06,0,0,1,4.35,6.25h-.56a48,48,0,0,1-4.94-.31,45.33,45.33,0,0,1,4.94-.31l-.27.48a53.59,53.59,0,0,1-3.52-6.1",
    transform: "translate(0 -0.13)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M74.68,220.34l-1-26.23s-23.87-50.4-8.69-57l15.91-3.38,3.94-6.45,11.94,5.21.81-4.7,5.1,3.92s8.09.55,12.14,2c0,0,14.3,7,40.13,33.17l35.78,2.61,1.35,11.73-42.38,1.25S139.9,178.6,123,163.12l5.2,26.47,3.11,26.61Z",
    transform: "translate(0 -0.13)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M94.44,136.62l1.09-3.86,2-.6,3,2.2-1,4.9s16.41,24.24,21.42,74.9l-3.46,8.93L106,215.92s5.69-18.26-8.81-75.12Z",
    transform: "translate(0 -0.13)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 140.38,
    y: 141.03,
    width: 64.51,
    height: 57.74
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 144.86,
    y: 145.04,
    width: 55.55,
    height: 49.72
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M135,204.63s-2.86-8.18-.49-13L89,185.46S78.23,137.68,65,138.25c0,0-15.88,3.12,8.68,57,0,0,0,6.67,21.12,7.24Z",
    transform: "translate(0 -0.13)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137,192.42v-4.64s-4.48.92-4.51,7.95c0,0,.23,8.32,2.56,10.58,0,0,3.67,2.68,11.44-.21,0,0,.68-2.15-5.47-1.45,0,0,7.2.29,7.68-1.59,0,0,.82-2.56-8.39-1.84,0,0,8.94.72,8.66-1.51,0,0,.4-1.73-3.67-1.92l-4.2-.51s7.06,1.46,6.5-1c0,0,.65-2.07-10.6-3.84",
    transform: "translate(0 -0.13)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 141.39,
    y1: 204.48,
    x2: 144.61,
    y2: 204.48
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 140.38,
    y1: 201.08,
    x2: 145.95,
    y2: 201.08
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 141.08,
    y1: 197.15,
    x2: 145.09,
    y2: 197.64
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(150.44 186.52)"
  }, "UI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(266.55 170.34)"
  }, "UI/UX DESIGN")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 261.24,
    y: 34.15,
    width: 240.91,
    height: 81.06,
    rx: 10.92
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M261.24,45H502.15S501.81,34.28,491,34.28l-220.23.12a11.83,11.83,0,0,0-7.52,4.49A10.48,10.48,0,0,0,261.24,45Z",
    transform: "translate(0 -0.13)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 283.02,
    cy: 40.12,
    r: 3.43
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 293.56,
    cy: 40.12,
    r: 3.43
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 304.04,
    cy: 40.12,
    r: 3.43
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 273.34,
    y: 57.21,
    width: 186.75,
    height: 9.22,
    rx: 4.61
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 273.34,
    y: 74.13,
    width: 117.68,
    height: 5.81,
    rx: 2.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 273.34,
    y: 87.63,
    width: 117.68,
    height: 5.81,
    rx: 2.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 443.06,
    y: 81.64,
    width: 46.02,
    height: 27.27,
    rx: 4.93
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 524.69,
    y: 115.64,
    width: 32.45,
    height: 12.06,
    rx: 6.03
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 531.08,
    cy: 121.8,
    r: 4.46
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 204.89,
    y: 70.28,
    width: 37.04,
    height: 13.77,
    rx: 6.88,
    transform: "translate(446.81 154.2) rotate(-180)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 234.63,
    cy: 77.18,
    r: 5.09
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M676.43,95.33s-.59-.89-4.2,4.3c0,0-.58-4.51,2.95-6.33s1.25,2,1.25,2",
    transform: "translate(0 -0.13)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M666.38,276.94c0-9.88.06-11.29.06-11.29l-6.76,11.29c-5,.14-30.07,0-37.3,0,12.35-27.57,25.6-52.43,25.6-52.43l.39-6.67L702,221.7c2.12,10.67.45,34-1.73,55.24C688.83,276.93,677.71,276.88,666.38,276.94Z",
    transform: "translate(0 -0.13)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M595.79,188.71l-.51-8.89-5.6-.12a6.71,6.71,0,0,0-3.15-3s-4.76-3.24-5.89-3.09c0,0-1.17.28,2.1,4.44,0,0,1.46,1.74-4.51,1.59,0,0-9.88.31-6.74,2.36,0,0-8.32,2,5.63,2.43-5.55.28-8.33.68-8.36,1.22s2.46,1.14,7.45,1.89c0,0-4,0-4.45.89,0,0-1.6,1.22,4.33,1.21,0,0,7.4.59,12-1.36l7.49.45",
    transform: "translate(0 -0.13)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M675.15,153.84s6.33-5.46,20.19-8.78c0,0-6.24-6.25.61-27.25l-16.1,11s1.95,12.71-6.64,13.29c0,0,0,8.38,1.94,11.77",
    transform: "translate(0 -0.13)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M681.32,134.2s13.57,1.16,16.65-11.36c0,0,3.73-13.5,2.54-17.81s-1.42-7.53-7-11.33a14.27,14.27,0,0,0-18.24,2,24.85,24.85,0,0,0-6,12s-2.57,14.34,1.1,18.84c0,0,3.77,7.11,10.93,7.65",
    transform: "translate(0 -0.13)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M693.66,113.48c.06-.23.24-.35.45-.81a4,4,0,0,0,.34-1.93,46.15,46.15,0,0,0-1.87-8.4,4.48,4.48,0,0,1,2.64-3.81s-3.48-5.26-10.75-2.16a11.57,11.57,0,0,1-3.74.68,11.34,11.34,0,0,1-5.43-1.35,6,6,0,0,1,1.81-11.82,18,18,0,0,1,3.41-1.08,19.52,19.52,0,0,1,10.25.67c10.09,1.72,17.15,6.14,17.54,11a6.24,6.24,0,0,1-.63,3.15,6.94,6.94,0,0,1,3.05,3.11c1.59,3.39,0,8.3-4.32,11.86a16,16,0,0,1-2.13,1.59,17.37,17.37,0,0,1-7.22,2.48C694.07,115,693.53,114,693.66,113.48Z",
    transform: "translate(0 -0.13)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M695.72,121.55s1.74,1.06,5.11-1.18c0,0,7.35-5,2.51-9.89,0,0-6.08-4.15-9.76,6.46,0,0-.58,3.81,2.14,4.61",
    transform: "translate(0 -0.13)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M682.6,110.34c-.1,1.14.46,2.13,1.23,2.19s1.48-.81,1.58-2-.46-2.13-1.23-2.19-1.48.81-1.58,2",
    transform: "translate(0 -0.13)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M672.26,108.26c-.09,1.14.46,2.13,1.23,2.19s1.48-.81,1.58-2-.46-2.13-1.23-2.19-1.48.81-1.58,2",
    transform: "translate(0 -0.13)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M688.46,107.49a11.12,11.12,0,0,0-3.09-1.72,4.07,4.07,0,0,0-1.63-.2,8.14,8.14,0,0,0-1.77.35,3.37,3.37,0,0,1,1.64-1.06,3.51,3.51,0,0,1,2,0,4.49,4.49,0,0,1,1.71,1A4.17,4.17,0,0,1,688.46,107.49Z",
    transform: "translate(0 -0.13)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M677.26,105.37a11.43,11.43,0,0,0-3.09-1.73,4.46,4.46,0,0,0-1.63-.2,8.78,8.78,0,0,0-1.77.35,3.35,3.35,0,0,1,1.64-1.05,3.51,3.51,0,0,1,2,0,4.46,4.46,0,0,1,1.71,1A4.28,4.28,0,0,1,677.26,105.37Z",
    transform: "translate(0 -0.13)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M680.06,125s-1.07-3-1.72-3.59a16.89,16.89,0,0,0,6.88-2.87s2.47,5.06-5.16,6.46",
    transform: "translate(0 -0.13)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M685.22,118.57v1.19s-3.19,2.45-5.27,2.45l-1-.88",
    transform: "translate(0 -0.13)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M677.26,111.29a50.54,50.54,0,0,0-4.13,5.92h.54a45.75,45.75,0,0,0,4.67-.3,45.73,45.73,0,0,0-4.67-.29l.25.45a50.88,50.88,0,0,0,3.34-5.77",
    transform: "translate(0 -0.13)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M702,223.36l.93-24.83s22.59-47.71,8.22-54l-15.06-3.19-3.73-6.11L681,140.18l-.76-4.45-4.83,3.71s-7.67.52-11.5,1.92c0,0-13.53,6.61-38,31.39l-33.87,2.48-1.28,11.1,40.13,1.19s9.3-3.67,25.31-18.33l-4.92,25.07-2.94,25.19Z",
    transform: "translate(0 -0.13)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M683.27,144.11l-1-3.65-1.89-.57L677.52,142l1,4.64S663,169.56,658.2,217.51l3.28,8.46,10.84-6.79s-5.39-17.29,8.34-71.11Z",
    transform: "translate(0 -0.13)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 578.72,
    y: 148.41,
    width: 61.06,
    height: 54.66,
    transform: "translate(1218.5 351.34) rotate(-180)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 582.96,
    y: 152.21,
    width: 52.58,
    height: 47.07,
    transform: "translate(1218.5 351.34) rotate(-180)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M644.9,208.5s2.71-7.75.46-12.33l43.11-5.82s10.15-45.23,22.66-44.69c0,0,15,3-8.21,54,0,0,0,6.31-20,6.85Z",
    transform: "translate(0 -0.13)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M643,196.94v-4.4s4.25.88,4.27,7.53c0,0-.22,7.88-2.43,10,0,0-3.47,2.54-10.82-.19,0,0-.64-2,5.17-1.38,0,0-6.81.27-7.26-1.51,0,0-.78-2.41,7.94-1.74,0,0-8.46.69-8.2-1.43,0,0-.38-1.63,3.48-1.81l4-.48s-6.68,1.38-6.16-1c0,0-.61-2,10-3.63",
    transform: "translate(0 -0.13)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 638.83,
    y1: 208.34,
    x2: 635.78,
    y2: 208.34
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 639.78,
    y1: 205.12,
    x2: 634.51,
    y2: 205.12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 639.12,
    y1: 201.41,
    x2: 635.32,
    y2: 201.87
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(585.43 188.7)"
  }, "UX")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 569.53,
    y: 60.56,
    width: 10.76,
    height: 12.52
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 585.99,
    y: 54.98,
    width: 9.61,
    height: 18.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 603.01,
    y: 45.54,
    width: 9.61,
    height: 27.53
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 620.62,
    y: 36.54,
    width: 9.61,
    height: 36.54
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-28",
    points: "570.15 57.35 579.77 57.35 585.99 50.5 595.61 50.5 600.84 43.11 612.63 43.11 619.89 33.67 630.23 33.67"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M291.78,247.4h0a8.64,8.64,0,0,0-.09-2.69h0L292.9,243l-.85-1.87L290,241h0a8.7,8.7,0,0,0-2-1.84h0l-.32-2-1.92-.72-1.6,1.32v0a8.71,8.71,0,0,0-2.7.09h0l-1.68-1.22-1.86.85-.2,2.06h0a8.42,8.42,0,0,0-1.84,2h0l-2.05.32-.72,1.92,1.32,1.59h0a8.71,8.71,0,0,0,.09,2.7h0l-1.21,1.67.84,1.87,2.06.19h0a8.43,8.43,0,0,0,2,1.84h0l.32,2,1.92.73,1.6-1.33h0a8.65,8.65,0,0,0,2.69-.1h0l1.68,1.22,1.87-.84.19-2.07h0a8.68,8.68,0,0,0,1.85-2h0l2.05-.33.72-1.92Zm-2.11,1.43a7,7,0,1,1-4.07-9,7,7,0,0,1,4.07,9",
    transform: "translate(0 -0.13)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 410.5,
    y: 228.04,
    width: 30.63,
    height: 24.58,
    rx: 6.44
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "420.59 234.85 420.59 246.22 433.04 240.53 420.59 234.85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiuXdesigntab);
export default __webpack_public_path__ + "static/media/UI UX design tab.e8d38cf2f13935d63eb33310d0127150.svg";
export { ForwardRef as ReactComponent };